// CLARTEXT SPRACHE – Ukrainische Mitarbeiter-UI (AP-LANG-UK, Juni 2026).
// Echte ukrainische Übersetzung der Monteur-App-UI (KEIN Re-Export mehr von de.js).
// ERSTE nicht-lateinische Sprache: kyrillische Schrift, vollständig UTF-8 kodiert.
// Schlüssel-IDENTISCH zu de.js; fehlende Schlüssel fallen über createT auf Deutsch
// zurück. Weltinhalte (Welt-Titel, Fragen, Antwortoptionen, GBU-/BA-Texte) sind
// Daten und kommen über den Read-Resolver (`display`), NICHT aus dieser Datei.
const uk = {
  // Gemeinsame
  "common.loading": "Завантаження…",

  // PIN-Login (/monteur/login)
  "login.eyebrow": "Вхід",
  "login.title": "Ваш PIN-код",
  "login.subtitle": "Код компанії + 4-значний PIN-код від вашого керівника.",
  "login.companyCodeLabel": "Код компанії",
  "login.companyCodePlaceholder": "напр. LUMPE",
  "login.submitting": "Виконується вхід…",
  "login.backAria": "Назад до входу",
  "login.errorNoCode": "Спершу введіть код компанії.",
  "login.errorUnknown": "Компанія або PIN-код невідомі.",

  // Aufgabenliste (/monteur)
  "tasks.companyFallback": "Ваше підприємство",
  "tasks.portalSubtitle": "Портал навчання",
  "tasks.loggedInAs": "Ви увійшли як",
  "tasks.heading": "Ваші завдання",
  "tasks.openCount": "{count} відкритих",
  "tasks.emptyToday": "Сьогодні немає відкритих завдань.",
  "tasks.newBanner": "У вас {count} нових інструктажів з часу останнього візиту.",
  "tasks.newBadge": "Нове",
  "tasks.newBannerDismissAria": "Закрити сповіщення",
  "tasks.backAria": "Назад до огляду",
  "home.tasksTitle": "Інструктажі",
  "home.searchTitle": "Довідник",
  "home.searchSubtitle": "Швидкий пошук інформації з безпеки",
  "home.hspTitle": "План захисту шкіри",
  "home.hspSubtitle": "Захист шкіри та вибір рукавиць",
  "home.driverTitle": "Перевірка посвідчення водія",
  "home.driverOpen": "Надішліть посвідчення водія",
  "home.driverSubmitted": "Очікує перевірки підприємством",
  "home.driverUpToDate": "Наразі дійсне",
  "home.settingsTitle": "Налаштування",
  "home.settingsSubtitle": "Керування e-mail та мовою",
  "home.comingSoon": "Незабаром",
  "home.newBubbleAria": "{count} нових інструктажів",
  "settings.profileTitle": "Профіль",
  "settings.profileHint": "Ім'я та підприємство веде роботодавець.",
  "settings.emailTitle": "E-mail для сповіщень",
  "settings.emailPurpose": "Використовується виключно для інформування про нові інструктажі.",
  "settings.emailPlaceholder": "imya@pryklad.ua",
  "settings.emailSave": "Зберегти",
  "settings.emailSaved": "Збережено",
  "settings.emailInvalid": "Введіть дійсну адресу e-mail.",
  "settings.emailRemoveHint": "Очистіть поле та збережіть, щоб відписатися.",
  "settings.saveError": "Не вдалося зберегти. Спробуйте ще раз.",
  "settings.privacyLink": "Політика конфіденційності",
  "settings.consentLabel": "Я хочу отримувати сповіщення електронною поштою про нові інструктажі.",
  "settings.languageTitle": "Мова",
  "settings.langNotBooked": "Сірі мови ще не замовлені вашою компанією. Зверніться до керівника, якщо хочете користуватися однією з них.",
  "tasks.quickLookup": "Швидкий пошук",
  "tasks.doneHeading": "Уже виконано",
  "tasks.dueLabel": "Термін",
  "tasks.doneAtLabel": "Виконано",
  "tasks.logoutAria": "Вийти",

  // Aufgabendetail (/monteur/aufgabe/:id)
  "aufgabe.notFound": "Завдання не знайдено.",
  "aufgabe.wrongOne":
    "Одна відповідь була неправильною. Будь ласка, дайте відповідь ще раз.",
  "aufgabe.wrongMany":
    "{count} відповідей були неправильними. Будь ласка, дайте відповідь ще раз.",
  "aufgabe.saveFailed": "Не вдалося зберегти. Будь ласка, спробуйте ще раз.",
  "aufgabe.doneTitle": "Готово!",
  "aufgabe.doneBody":
    "Інструктаж „{title}“ завершено. Ваш підтверджувальний документ створено автоматично та збережено в контрольній теці вашого підприємства.",
  "aufgabe.backToTasks": "Назад до моїх завдань",
  "aufgabe.stepContent": "Зміст",
  "aufgabe.stepQuestion": "Питання {current} з {total}",
  "aufgabe.backShort": "Завдання",
  "aufgabe.readCalm": "Будь ласка, уважно прочитайте.",
  "aufgabe.questionsFollow": "Потім буде {count} коротких запитань для перевірки.",
  "aufgabe.questionLabel": "Запитання для перевірки {current} / {total}",
  "aufgabe.wrongAgain":
    "Ця відповідь була неправильною минулого разу. Будь ласка, виберіть ще раз.",
  "aufgabe.prev": "Назад",
  "aufgabe.saving": "Збереження…",
  "aufgabe.finish": "Завершити інструктаж",
  "aufgabe.toQuestions": "До запитань",
  "aufgabe.next": "Далі",

  // Nachschlage-Suche (Komponente MonteurWeltSuche)
  "suche.placeholder": "Пошук – напр. „акумулятор“, „окуляри“, „драбина“…",
  "suche.inputAria": "Пошук у документації",
  "suche.matchIn": "Збіг у {label}:",
  "suche.empty": "Відповідної документації не знайдено.",
  "suche.emptyHint": "Спробуйте інше слово, напр. „ЗІЗ“ або „бинт“.",

  // Welt-Nachschlagewerk (/monteur/welt/:id) – NUR UI-Rahmen/Labels.
  "welt.headerTitle": "Пошук",
  "welt.backAria": "Назад",
  "welt.errorNotAvailable": "Ця документація наразі недоступна.",
  "welt.errorLoad": "Не вдалося завантажити світ.",
  "welt.backToTasks": "Назад до моїх завдань",
  "welt.loading": "Завантаження світу…",
  "welt.doctype": "Довідник",
  "welt.versionLabel": "Версія",
  "welt.gbuTitle": "Оцінка ризиків",
  "welt.noHazards": "Окремі небезпеки не задокументовано.",
  "welt.residualRisk": "Залишковий ризик:",
  "welt.measureTechnical": "Технічні",
  "welt.measureOrganizational": "Організаційні",
  "welt.measurePersonal": "Особисті",
  "welt.responsible": "Відповідальний:",
  "welt.baTitle": "Інструкція з експлуатації",
  "welt.baSubtitle": "Згідно з TRBS / GefStoffV / BetrSichV",
  "welt.mainHazards": "Основні небезпеки",
  "welt.protectiveMeasures": "Захисні заходи та правила поведінки",
  "welt.emergency": "У надзвичайній ситуації",
  "welt.firstAid": "Перша допомога",
  "welt.disposalHazmat": "Зберігання та утилізація",
  "welt.disposalVehicle": "Паркування",
  "welt.disposalDefault": "Виведення з експлуатації",
  "welt.instructionTitle": "Інструктаж",
  "welt.instructionSubtitle": "Згідно з DGUV V1 §4",
  "welt.visualTitle": "Візуальні навчальні матеріали",
  "welt.visualSubtitle":
    "Підтримують розуміння – не змінюють жодного змісту, документів чи PDF",
  "welt.questionsTitle": "Запитання для перевірки",
  "welt.questionsSubtitle":
    "{count} запитань — самоперевірка без позначення правильної відповіді",
  "welt.maintenanceTitle": "Вказівки щодо перевірки та обслуговування",
  "welt.maintenanceSubtitle": "Згідно з BetrSichV / UVV",
  "welt.performedBy": "Виконання:",
  "welt.recommendedCheck": "Рекомендована фахова перевірка:",
  "welt.recurrenceTitle": "Цикли повторення",
  "welt.recurrenceSubtitle": "Для кожного модуля – автоматично контролюється системою",
  "welt.recurrenceUnterweisung": "Інструктаж",
  "welt.recurrenceGbuReview": "Оцінка ризиків – перегляд",
  "welt.recurrenceWartung": "Обслуговування / перевірка",
  "welt.recurrence.none": "–",
  "welt.recurrence.einmalig": "Одноразово",
  "welt.recurrence.monatlich": "Щомісяця",
  "welt.recurrence.vierteljaehrlich": "Щокварталу",
  "welt.recurrence.halbjaehrlich": "Раз на півроку",
  "welt.recurrence.jaehrlich": "Щороку",
  "welt.recurrence.zwei_jahre": "Кожні 2 роки",

  // Aufgaben-Status (StatusBadge)
  "status.offen": "Відкрито",
  "status.erledigt": "Виконано",
  "status.ueberfaellig": "Прострочено",

  // Feste Abschnitts-Überschriften (content[].heading). Lookup-Schlüssel bleibt der
  // DEUTSCHE Quell-Heading; nur der WERT ist ukrainisch. DB/Beweiskette bleiben deutsch.
  "contentHeading.Worum geht es?": "Про що йдеться?",
  "contentHeading.Welche Gefahren bestehen?": "Які небезпеки існують?",
  "contentHeading.Vor Arbeitsbeginn beachten": "Що врахувати перед початком роботи",
  "contentHeading.Während der Arbeit beachten": "Що врахувати під час роботи",
  "contentHeading.Nach der Arbeit beachten": "Що врахувати після роботи",

  // UI-/Präsentationslabels der visuellen Lernschicht (VLOs).
  "vlo.safetySymbols.title": "Знаки безпеки",
  "vlo.safetySymbols.hint":
    "Ці знаки підтримують інструктаж. Визначальним завжди є текст.",
  "vlo.psaSummary.title": "Підсумок ЗІЗ",
  "vlo.hazardMarkers.title": "Позначки небезпеки",
  "vlo.learningFocus.title": "Фокус навчання",
  "vlo.richtigFalsch.title": "Правильно та неправильно",
  "vlo.richtigFalsch.correct": "Правильно",
  "vlo.richtigFalsch.wrong": "Неправильно",

  // PRINT.1 (Juni 2026) – мітки плаката (елементи UI друкованого плаката).
  "plakat.eyebrow": "Інструктажний плакат",
  "plakat.subtitle": "Працюйте безпечно – найважливіші правила коротко",
  "plakat.symbols": "Знаки безпеки",
  "plakat.hazards": "Небезпеки",
  "plakat.richtigFalsch": "Правильно і неправильно",
  "plakat.correct": "Правильно",
  "plakat.wrong": "Неправильно",
  "plakat.psa": "Засоби індивідуального захисту (ЗІЗ)",
  "plakat.rules": "Найважливіші правила",
  "plakat.qrTitle": "Відкрити світ напряму",
  "plakat.qrText": "Відскануйте QR-код телефоном, введіть PIN – цей світ документації відкриється одразу.",
  "plakat.footerHint": "Цей плакат підтримує інструктаж. Обов'язковим залишається повний інструктаж.",
  "plakat.moreInFull": "Більше змісту в повному інструктажі",

  // AP-PLAKAT-UX (Juni 2026) – підзаголовки груп + багатосторінковість.
  "plakat.hazardsSub": "Що може статися?",
  "plakat.correctSub": "Як працювати безпечно.",
  "plakat.wrongSub": "Як не можна працювати.",
  "plakat.continued": "продовження",
  "plakat.page": "Сторінка",
};

const ukExtra = {
  "aushang.linkTitle": "Закони та приписи, обов'язкові для розміщення",
  "aushang.linkSubtitle": "Офіційні оригінальні тексти",
  "aushang.pageTitle": "Закони та приписи, обов'язкові для розміщення",
  "aushang.categoryAllgemein": "Загальні правові основи",
  "aushang.categoryDguv": "Приписи DGUV та технічні правила",

  "common.back": "Назад",
  "common.notEnabled": "Цей розділ не активовано для вашої компанії.",

  "aushang.kicker": "Обов'язкове розміщення",
  "aushang.intro": "Посилання на офіційні оригінальні тексти. Оператор веде список централізовано; оновлення перевіряються перед публікацією.",
  "aushang.loadError": "Не вдалося завантажити список.",
  "aushang.listLoading": "Завантаження…",
  "aushang.listEmpty": "Поки що немає записів — оператор веде список через консоль оператора.",
  "aushang.categoryEmpty": "У цій категорії немає записів.",

  "hsp.kicker": "План захисту рук",
  "hsp.titleFallback": "План захисту шкіри та рук",
  "hsp.loadError": "Не вдалося завантажити план захисту рук.",
  "hsp.empty": "Для цієї робочої зони наразі немає плану захисту рук.",
  "hsp.plakatCreatingTitle": "Плакат створюється",
  "hsp.plakatCreatingText": "Під час першого відкриття генеруються зображення — це може тривати до двох хвилин. Після цього плакат буде доступний одразу.",
  "hsp.plakatFailedTitle": "Не вдалося створити плакат.",
  "hsp.plakatFailedHint": "Будь ласка, спробуйте ще раз. Текстовий вигляд доступний нижче.",
  "hsp.plakatReload": "Не вдалося завантажити плакат. Будь ласка, оновіть сторінку.",
  "hsp.plakatTimeout": "Створення триває довше, ніж очікувалося. Спробуйте пізніше.",
  "hsp.plakatRetry": "Не вдалося створити плакат. Спробуйте ще раз.",
  "hsp.plakatLoadFailed": "Не вдалося завантажити плакат.",
  "hsp.plakatImgError": "Не вдалося показати зображення плаката.",
  "hsp.plakatAlt": "Плакат плану захисту рук",
  "hsp.plakatLoadingAria": "Плакат завантажується",
  "hsp.textOpen": "Показати як текст",
  "hsp.textClose": "Закрити текстовий вигляд",
  "hsp.thWas": "Що",
  "hsp.thWann": "Коли",
  "hsp.thWomit": "Чим",
  "hsp.thWie": "Як",
  "hsp.firstAidTitle": "Перша допомога після контакту зі шкірою",
  "hsp.gsvOne": "1 небезпечна речовина в цій зоні",
  "hsp.gsvMany": "Небезпечні речовини в цій зоні: {count}",
  "hsp.gsvMenge": "Кількість на підприємстві:",
  "hsp.gsvHSaetze": "H-фрази:",
  "hsp.psaHandschutz": "Захист рук",
  "hsp.psaAtemschutz": "Захист органів дихання",
  "hsp.psaAugenschutz": "Захист очей",
  "hsp.psaKoerperschutz": "Захист тіла",
  "hsp.psaErsteHilfe": "Перша допомога після контакту зі шкірою",
  "hsp.psaAetzReiz": "Їдка/подразнювальна дія",
  "hsp.psaSensibilisierung": "Сенсибілізація",
  "hsp.psaPSaetze": "P-фрази",

  "fuehrerschein.title": "Перевірка посвідчення водія",
  "fuehrerschein.loadError": "Не вдалося завантажити завдання.",
  "fuehrerschein.notApplicable": "Наразі для вас не передбачено перевірку посвідчення водія.",
  "fuehrerschein.categoriesTitle": "Ваші типи транспортних засобів",
  "fuehrerschein.categoriesSubtitle": "Ці типи транспортних засобів визначив для вас роботодавець.",
  "fuehrerschein.categoriesEmpty": "Категорії не призначено.",
  "fuehrerschein.upToDateTitle": "Посвідчення водія наразі дійсне",
  "fuehrerschein.upToDateText": "Наразі перевірка не потрібна.",
  "fuehrerschein.nextDue": "Наступна перевірка до",
  "fuehrerschein.lastDecision": "Останнє підтвердження:",
  "fuehrerschein.submittedTitle": "Успішно надіслано",
  "fuehrerschein.submittedText": "Фото посвідчення та декларація тепер у роботодавця на перевірці.",
  "fuehrerschein.submittedAt": "Надіслано",
  "fuehrerschein.declarationTitle": "Декларація",
  "fuehrerschein.declarationAccept": "Я прочитав(-ла) декларацію та підтверджую її.",
  "fuehrerschein.photoFrontTitle": "Фото посвідчення: лицьовий бік",
  "fuehrerschein.photoFrontHint": "Будь ласка, чітко сфотографуйте лицьовий бік посвідчення (видно ім'я та дату закінчення).",
  "fuehrerschein.photoBackTitle": "Фото посвідчення: зворотний бік",
  "fuehrerschein.photoBackHint": "Будь ласка, чітко сфотографуйте зворотний бік посвідчення (видно таблицю категорій).",
  "fuehrerschein.previewFrontAlt": "Попередній перегляд: лицьовий бік",
  "fuehrerschein.previewBackAlt": "Попередній перегляд: зворотний бік",
  "fuehrerschein.otherPhoto": "Інше фото",
  "fuehrerschein.remove": "Видалити",
  "fuehrerschein.pickFront": "Сфотографувати лицьовий бік або вибрати файл",
  "fuehrerschein.pickBack": "Сфотографувати зворотний бік або вибрати файл",
  "fuehrerschein.pickLimits": "Макс. 12 МБ · JPEG, PNG, WEBP, HEIC",
  "fuehrerschein.submit": "Надіслати",
  "fuehrerschein.submitting": "Надсилання…",
  "fuehrerschein.submitSuccess": "Успішно надіслано.",
  "fuehrerschein.submitFailed": "Не вдалося надіслати. Спробуйте ще раз.",
  "fuehrerschein.errFormat": "Формат зображення не підтримується. Виберіть JPEG, PNG, WEBP, HEIC або HEIF.",
  "fuehrerschein.errSize": "Файл завеликий. Максимум: 12 МБ.",
  "fuehrerschein.ocrPreparing": "Готується автоматичне зчитування…",
  "fuehrerschein.ocrUnavailable": "OCR тимчасово недоступний — перевірте посвідчення вручну.",
  "fuehrerschein.ocrBannerStrong": "Автоматичне зчитування",
  "fuehrerschein.ocrBannerRest": " — без перевірки з боку CLartext, не замінює візуальний контроль.",
  "fuehrerschein.ocrName": "Ім'я (зчитано)",
  "fuehrerschein.ocrExpiry": "Дата закінчення (зчитано)",
  "fuehrerschein.ocrClasses": "Категорії (зчитано)",
};
Object.assign(uk, ukExtra);

export default uk;
